/**
 *  PauseScene
 *
 *  Created by Legman on 27/03/2016.
 *
 */

import Common from "../Common";
import isMobile from "ismobilejs";

/**
 * @class
 */
export default class PauseScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._overlay = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._panel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._homeButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._muteButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._resumeButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._replayButton = null;

        /**
         * @type {Array.<PIXI.Texture>}
         * @private
         */
        this._images = [];

        /**
         * @type {number}
         * @private
         */
        this._index = 0;

        /**
         * @type {Array.<PIXI.Sprite>}
         * @private
         */
        this._pageIndicators = [];
    }

    init() {
        super.init();

        const assets = Common.assets;

        this._panel = new PIXI.Sprite(assets.getTexture("ui_help_bg"));
        this._panel.x = Common.STAGE_WIDTH * 0.5;
        this._panel.y = Common.STAGE_HEIGHT + 12;
        this._panel.anchor = new PIXI.Point(0.5, 1);
        this._panel.visible = false;
        this.addChild(this._panel);

        if (language === "ar") {
            this._panel.title = new PIXI.Text(translate("pause_title"), {
                fontSize: "40px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6});
            this._panel.title.y = -636;
            this._panel.title.pivot.x = this._panel.title.width * 0.5;
            this._panel.title.pivot.y = this._panel.title.height * 0.5;
            this._panel.addChild(this._panel.title);
        } else {
            this._panel.title = new PIXI.BitmapText(translate("pause_title"), font(44, "center"));
            this._panel.title.y = -636;
            this._panel.title.pivot.x = this._panel.title.textWidth * 0.5;
            this._panel.title.pivot.y = this._panel.title.textHeight * 0.5;
            this._panel.addChild(this._panel.title);
        }

        this._panel.image = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._panel.image.y = -this._panel.height * 0.5;
        this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.addChild(this._panel.image);

        this._panel.image.mask = new PIXI.Graphics();
        this._panel.addChild(this._panel.image.mask);

        this._panel.roll = new PIXI.Sprite(assets.getTexture("ui_help_roll"));
        this._panel.roll.x = 6;
        this._panel.roll.y = -560;
        this._panel.roll.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.roll.start = new PIXI.Point(this._panel.roll.x, this._panel.roll.y);
        this._panel.addChild(this._panel.roll);

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_play");

        this._resumeButton = new p3.Button(states);
        this._resumeButton.visible = false;
        this._resumeButton.interactive = false;
        this._resumeButton.overSoundName = "sfx_btn_rollover_00";
        this._resumeButton.clickSoundName = "sfx_btn_press_00";
        this._resumeButton.signals.click.add(this.onResumeButtonClick, this);
        this.addChild(this._resumeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_home");

        this._homeButton = new p3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.interactive = false;
        this._homeButton.overSoundName = "sfx_btn_rollover_00";
        this._homeButton.clickSoundName = "sfx_btn_press_00";
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_sound_on");
        states.iconAlt = assets.getTexture("ui_icon_sound_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.visible = false;
        this._muteButton.interactive = false;
        this._muteButton.overSoundName = "sfx_btn_rollover_00";
        this._muteButton.clickSoundName = "sfx_btn_press_00";
        this.addChild(this._muteButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_replay");

        this._replayButton = new p3.Button(states);
        this._replayButton.visible = false;
        this._replayButton.interactive = false;
        this._replayButton.overSoundName = "sfx_btn_rollover_00";
        this._replayButton.clickSoundName = "sfx_btn_press_00";
        this._replayButton.signals.click.add(this.onReplayButtonClick, this);
        this.addChild(this._replayButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_arrow_r");

        this._nextButton = new p3.Button(states);
        this._nextButton.visible = false;
        this._nextButton.interactive = false;
        this._nextButton.overSoundName = "sfx_btn_rollover_00";
        this._nextButton.clickSoundName = "sfx_btn_press_00";
        this._nextButton.signals.click.add(this.onNextButtonClick, this);
        this.addChild(this._nextButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_arrow_l");

        this._previousButton = new p3.Button(states);
        this._previousButton.visible = false;
        this._previousButton.interactive = false;
        this._previousButton.overSoundName = "sfx_btn_rollover_00";
        this._previousButton.clickSoundName = "sfx_btn_press_00";
        this._previousButton.signals.click.add(this.onPreviousButtonClick, this);
        this.addChild(this._previousButton);

        this._images = [
            {texture: !isMobile.any ? assets.getTexture("ui_help_01") : assets.getTexture("ui_help_01_mobile"), text: isMobile.any ? translate("pause_info1_mobile") : translate("pause_info1")},
            {texture: assets.getTexture("ui_help_02"), text: translate("pause_info2")},
            {texture: assets.getTexture("ui_help_03"), text: translate("pause_info3")},
            {texture: assets.getTexture("ui_help_04"), text: translate("pause_info4")}
        ];

        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([assets.getTexture("ui_pagination_off"), assets.getTexture("ui_pagination_on")]);

        const holder = new PIXI.Container();
        holder.x = Common.STAGE_WIDTH * 0.5;
        holder.y = 740;
        this.addChild(holder);

        const spacing = new PIXI.Point(40, -8);
        for (let i = 0; i < this._images.length; ++ i) {
            const indicator = new p3.MovieClip(sequence);
            indicator.x = i * spacing.x - ((this._images.length - 1) * spacing.x) * 0.5;
            indicator.y = (i % 2) * spacing.y;
            indicator.anchor = new PIXI.Point(0.5, 0.5);
            indicator.visible = false;
            holder.addChild(indicator);
            this._pageIndicators.push(indicator);

            if (i === this._index) indicator.gotoAndStop(1);
            else indicator.gotoAndStop(0);
        }
    }

    hide() {
        super.hide();

        this._panel.y = Common.STAGE_HEIGHT + 12;

        this._panel.image.texture = PIXI.Texture.EMPTY;

        this._panel.roll.y = this._panel.roll.start.y;
        this._panel.roll.scale = new PIXI.Point(1, 1);
        this._panel.roll.visible = true;
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        const to = this._panel.y;
        this._panel.y = this._panel.y + 40;
        TweenMax.to(this._panel, 0.34, {
            y: to,
            ease: Power1.easeInOut,
            onStart: function() {
                this._panel.visible = true;
            },
            onStartScope: this
        });

        this._panel.scale.y = 0;
        TweenMax.to(this._panel.scale, 0.34, {
            y: 1,
            ease: Back.easeInOut,
            easeParams: [2],
            onComplete: function() {
                this.showPage(this._index);
            },
            onCompleteScope: this
        });

        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.4, {
            delay: 0.1,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._homeButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.4, {
            delay: 0.1 * 0.06,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._muteButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._previousButton.scale = new PIXI.Point();
        TweenMax.to(this._previousButton.scale, 0.4, {
            delay: 0.1 * 0.06 * 2,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._previousButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._previousButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._nextButton.scale = new PIXI.Point();
        TweenMax.to(this._nextButton.scale, 0.4, {
            delay: 0.1 * 0.06 * 2,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._nextButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._nextButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._resumeButton.scale = new PIXI.Point();
        TweenMax.to(this._resumeButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 4,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._resumeButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._resumeButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._replayButton.scale = new PIXI.Point();
        TweenMax.to(this._replayButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 4,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._replayButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._replayButton.interactive = true;
            },
            onCompleteScope: this
        });

        for (let i = 0; i < this._pageIndicators.length; ++ i) {
            const indicator = this._pageIndicators[i];
            indicator.scale = new PIXI.Point();
            TweenMax.to(indicator.scale, 0.24, {
                delay: 0.3 + i * 0.04,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function(indicator) {
                    indicator.visible = true;
                },
                onStartParams: [indicator],
                onStartScope: this
            })
        }
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
        const tl = new TimelineMax({onComplete: callback, onCompleteScope: scope});

        tl.insert(TweenMax.to(this._panel, 0.34, {
            y: this._panel.y + 40,
            ease: Power1.easeInOut
        }));
        tl.insert(TweenMax.to(this._panel.scale, 0.34, {
            y: 0,
            ease: Back.easeInOut,
            easeParams: [1],
            onComplete: function() {
                this._panel.visible = false;
            },
            onCompleteScope: this
        }));

        this._homeButton.interactive = false;
        tl.insert(TweenMax.to(this._homeButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._homeButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._muteButton.interactive = false;
        tl.insert(TweenMax.to(this._muteButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._muteButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._nextButton.interactive = false;
        tl.insert(TweenMax.to(this._nextButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._nextButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._previousButton.interactive = false;
        tl.insert(TweenMax.to(this._previousButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._previousButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._resumeButton.interactive = false;
        tl.insert(TweenMax.to(this._resumeButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._resumeButton.visible = false;
            },
            onCompleteScope: this
        }));

        this._replayButton.interactive = false;
        tl.insert(TweenMax.to(this._replayButton.scale, 0.24, {
            x: 0,
            y: 0,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: function() {
                this._replayButton.visible = false;
            },
            onCompleteScope: this
        }));

        for (let i = 0; i < this._pageIndicators.length; ++ i) {
            const indicator = this._pageIndicators[i];
            tl.insert(TweenMax.to(indicator.scale, 0.14, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function() {
                    indicator.visible = false;
                },
                onCompleteScope: this
            }));
        }
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;

        this._homeButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
        this._homeButton.y = 100;

        this._muteButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._muteButton.y = 100;

        this._nextButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._nextButton.y = Common.STAGE_HEIGHT * 0.5;

        this._previousButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
        this._previousButton.y = Common.STAGE_HEIGHT * 0.5;

        this._resumeButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 120;
        this._resumeButton.y = p3.View.height - 120;

        this._replayButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
        this._replayButton.y = p3.View.height - 120;
    }

    update() {
        const input = Common.input;
        if (input.isKeyPressed(32)) {
            this.onResumeButtonClick(null);
        }
    }

    /**
     * @param {number} [index]
     */
    showPage(index) {
        const image = this._images[index];
        this._panel.image.texture = image.texture

        this._panel.roll.y = this._panel.roll.start.y;
        TweenMax.killTweensOf(this._panel.roll);
        TweenMax.to(this._panel.roll, 0.4, {
            y: this._panel.roll.y + 354,
            ease: Power2.easeInOut,
            onStart: function() {
                this._panel.roll.visible = true;
            },
            onStartScope: this
        });
        this._panel.roll.scale = new PIXI.Point(1, 1);
        TweenMax.killTweensOf(this._panel.roll.scale);
        TweenMax.to(this._panel.roll.scale, 0.4, {
            x: 0.93,
            y: 0.1,
            ease: Power2.easeInOut,
            onComplete: function() {
                this._panel.roll.visible = false;
            },
            onCompleteScope: this
        });

        const width = this._panel.image.texture.width;
        const height = this._panel.image.texture.height;

        this._panel.image.mask.clear();
        this._panel.image.mask.beginFill(0xFF0000);
        this._panel.image.mask.drawRect(-width * 0.5, -height * 0.5, width, height);
        this._panel.image.mask.endFill();

        this._panel.image.mask.y = this._panel.roll.y - height * 0.5;
        TweenMax.killTweensOf(this._panel.image.mask);
        TweenMax.to(this._panel.image.mask, 0.418, {
            y: this._panel.image.mask.y + 370,
            ease: Power2.easeInOut
        });

        // show the correct page indicator
        for (let i = 0; i < this._pageIndicators.length; ++ i) {
            const indicator = this._pageIndicators[i];
            if (i === index) indicator.gotoAndStop(1);
            else indicator.gotoAndStop(0);
        }

        Common.audio.playSound("ui_tracks_poster_reveal_00");
    }

    /**
     * @param {p3.Button} button
     */
    onNextButtonClick(button) {
        if (++ this._index >= this._images.length) {
            this._index = 0;
        }
        this.showPage(this._index);
    }

    /**
     * @param {p3.Button} button
     */
    onPreviousButtonClick(button) {
        if (-- this._index < 0) {
            this._index = this._images.length - 1;
        }
        this.showPage(this._index);
    }

    /**
     * @param {p3.Button} button
     */
    onHomeButtonClick(button) {
        this.animateOut(function() {
            this.signals.home.dispatch(this);
        }, this);

        Common.audio.playSound("sfx_whistle_fall_00");
    }

    /**
     * @param {p3.Button} button
     */
    onResumeButtonClick(button) {
        this.animateOut(function() {
            this.signals.next.dispatch(this);
        }, this);

        Common.audio.playSound("sfx_whistle_rise_00");
    }

    /**
     * @param {p3.Button} button
     */
    onReplayButtonClick(button) {
        this.animateOut(function() {
            this.signals.previous.dispatch(this);
        }, this);

        Common.audio.playSound("sfx_whistle_fall_00");
    }
}
